// extracted by mini-css-extract-plugin
export default {"icon":"ReplyButton-icon-0ac020f222436fb3e181e61baf10a557"};